import { createContext, useEffect, useMemo, useState } from "react";
const responseDummy = {
  isEncrypt: true,
  listFeature: {
    organization: true,
    businessProcess: true,
    matrix: true,
    jobDesc: true,
    workloadAssessment: true
  }
}

export const FeatureFlags = createContext({});
export const FeatureFlagsProvider = ({ children }) => {
  const [features, setFeatures] = useState({});

  useEffect(() => {
    if (responseDummy) {
      setFeatures(responseDummy.listFeature);
    }
  }, []);

  const value = useMemo(() => {
    return features
  }, [features])
  return (
    <FeatureFlags.Provider value={value}>
      {children}
    </FeatureFlags.Provider>
  );
};